import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { ENVIRONMENT_CONFIG } from "../config/environment.config.token";
@Injectable({ providedIn: 'root' })
export abstract class ApiService {
  protected baseURL: string;
  protected persionBaseURL: string;
  protected doctorBaseURL: string;
  protected commonBaseURL: string;
  protected clinicsBaseURL: string;
  protected appointmentBaseURL: string;
  protected scheduleBaseURL: string;
  protected identityBaseUrl: string;
  protected reportBaseUrl: string;
  protected geometryReaderUrl: string;
  protected storageBaseUrl: string;
  protected notificationBaseUrl: string;
  protected pharmacyUrl: string;
  protected cashboxUrl: string;
  protected queueUrl: string;
  protected documentTemplatingUrl: string;
  protected hl7service: string;

  constructor(protected http: HttpClient, @Inject(ENVIRONMENT_CONFIG) environment) {
    this.commonBaseURL = environment.env.commonUrl;
    this.identityBaseUrl = environment.env.identityUrl;
    this.clinicsBaseURL = environment.env.clinicsUrl;
    this.reportBaseUrl = environment.env.reportUrl;
    this.geometryReaderUrl = environment.env.geometryReaderUrl;
    this.storageBaseUrl = environment.env.storageUrl;
    this.appointmentBaseURL = environment.env.appointmentUrl;
    this.scheduleBaseURL = environment.env.scheduleUrl;
    this.persionBaseURL = environment.env.personUrl;
    this.doctorBaseURL = environment.env.doctorUrl;
    this.notificationBaseUrl = environment.env.notificationUrl;
    this.pharmacyUrl=environment.env.pharmacyUrl;
    this.cashboxUrl=environment.env.cashboxUrl;
    this.queueUrl=environment.env.queueUrl;
    this.documentTemplatingUrl=environment.env.documentTemplatingUrl;
    this.hl7service=environment.env.hl7service;
  }
}
